/*=========================================================================================
  File Name: moduleEcommerceActions.js
  Description: Ecommerce Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
  Author: SweetAs
  Author URL: http://sweetas.xyz
==========================================================================================*/

export default {
  toggleAllItemsInCart ({ commit }, item) {
    commit('REMOVE_ALL_ITEMS_FROM_CART', item)
  },
  toggleItemInCart ({ getters, commit, dispatch }, item) {
    getters.isInCart(item.sku) ? commit('REMOVE_ITEM_FROM_CART', item) : dispatch('additemInCart', item)
  },
  additemInCart ({ commit }, item) {
    item['quantity'] = 1
    commit('ADD_ITEM_IN_CART', item)
  },
  updateItemQuantity ({ commit }, payload) {    
    commit('UPDATE_ITEM_QUANTITY', payload)
  },
  updateIpId ({ commit }, payload) {
    commit('UPDATE_IPID', payload)
  }
}
